import Errormsg from "./Errormsg.vue";
export default Errormsg;
